module.exports = __webpack_public_path__ + "img/clock.167a99d6.png";